import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button, Image } from 'react-bootstrap';
import LoadingPlaceholder from './../../shared/LoadingPlaceholder';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyReservation } from './../../../actions';

import './bestfriend.scss';

const bestFriendBotIcon = require('./../../../images/best_friend_bot_icon_white.png');
const fbChatIcon = require('./../../../images/fb_chat.png');
const whatsappChatIcon = require('./../../../images/whatsapp_chat.png');

class BestFriend extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.actions.customerJourneyReservation(this.props.token, this.props.currentLanguage, this.props.context);
  }

  render() {

    const apiData = (this.props.reservation.apiData || {})
    const botData = (this.props.reservation.apiData.bot || {})
    const whatsappData = (this.props.reservation.apiData.whatsapp || {})

    if(!( apiData.contact_method == "bot" && botData.enabled ) && !( apiData.contact_method == "whatsapp" && whatsappData.enabled )) {
      return <div><br/><br/></div>; // just leave same space
    }

    let chatButton = null
    
    switch (apiData.contact_method) {
      case "whatsapp":
          if(whatsappData.enabled) {
            chatButton = <Button className="shared-bestfriend-component__whatsapp-chat-button" href={whatsappData.link} target="_blank">
                          <Image src={whatsappChatIcon} rounded height={32}/> {this.props.translate('shared.best_friend.whatsapp_chat_button')}
                        </Button>
          }
        break;
      case "bot":
          if((this.props.reservation.apiData.bot  || {}).enabled) {
            chatButton = <Button className="shared-bestfriend-component__fb-chat-button" href={botData.link} target="_blank">
                          <Image src={fbChatIcon} rounded height={32}/> {this.props.translate('shared.best_friend.fb_chat_button')}
                        </Button>
          }
        break;
      default:
          // do nothing keep button null
        break;
    }

    return (
      <Row className="shared-bestfriend-component">
        <Col xs={12}>
          <LoadingPlaceholder ready={!this.props.reservation.loading} text-align="center">
            <div className="text-center">
              <img src={bestFriendBotIcon} alt="Chat with Best Western Best Friend"/>
              <h3><strong>Best Western Best Friend</strong></h3>
              <h4>{this.props.translate('shared.best_friend.ask_me_anything')}</h4>
            </div>

            <br/>
            <br/>
            
            <div className="text-center">
              { chatButton }
            </div>
          </LoadingPlaceholder>
        </Col>
      </Row>
    );
  }
}

BestFriend.displayName = 'PagesSharedBestFriend';
BestFriend.propTypes = {};
BestFriend.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    token: state.commons.token,
    context: state.commons.context,
    reservation: state.reservation
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyReservation: bindActionCreators(customerJourneyReservation, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BestFriend);



// WEBPACK FOOTER //
// ./components/pages/shared/BestFriend.js